import { Expression, NamedColumn } from '../../../types';

export default function futureDateHandler(
  daysInFuture: number, column: NamedColumn, expression: Expression,
): Expression {
  return {
    ...expression,
    field: column.identifier(),
    operator: 'date_days_from_now',
    value: [`${daysInFuture}`],
  };
}
